<template>
  <EmptyState :title="items.default.title" :subtitle="items.default.text">
    <template #illustration>
      <Picture maxWidth="400" class="mb-12" :src="items.default.illustration"/>
    </template>
    <template #actions>
      <div v-for="(item, index) in items.actions" :key="index">
        <Button v-bind="item" :ga="gEvents.voltarParaLista" :label="item.title" color="primary" @click="successfully"/>
      </div>
    </template>
  </EmptyState>
</template>

<script>
import { Button, EmptyState, Picture } from '@locaweb/design-system-vue'

export default {
  name: 'SiteConclusion',
  components: {
    Button,
    EmptyState,
    Picture
  },
  props: {
    items: Object
  },
  methods: {
    successfully () {
      this.$emit('successfully')
    }
  },
  computed: {
    gEvents () {
      return this.$gEvents('criarNovoSite')
    }
  }
}
</script>
